import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=48e793bb&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48e793bb')) {
      api.createRecord('48e793bb', component.options)
    } else {
      api.reload('48e793bb', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=48e793bb&", function () {
      api.rerender('48e793bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/Notifications.vue"
export default component.exports